import React from 'react';
import classnames from 'classnames';

import { AVAILABLE, AWAY, UNAVAILABLE } from 'modules/common/constants/userAvailabilityTypes';

import { IconWithDotBadge } from 'shared/components';
import theme from './AvailabilityIconWithDotBadge.scss';


const getAvailabilityMessage = (availability) => {
  switch (availability) {
    case AVAILABLE:
      return { id: 'General.Available', defaultMessage: '** Available' };
    case UNAVAILABLE:
      return { id: 'General.Unavailable', defaultMessage: '** Unavailable' };
    case AWAY:
      return { id: 'General.Away', defaultMessage: '** Away' };
    default:
      return null;
  }
};

const AvailabilityIcon = ({ availability }) => {
  switch (availability) {
    case AVAILABLE:
      return <span className={ classnames(theme.availabilityBadge, theme.available) } />;
    case UNAVAILABLE:
      return <span className={ classnames(theme.availabilityBadge, theme.unavailable) } />;
    case AWAY:
      return <span className={ classnames(theme.availabilityBadge, theme.away) } />;
    default:
      return null;
  }
};

const AvailabilityIconWithDotBadge = ({ availability, ...rest }) => (
  <div className={ theme.root }>
    <IconWithDotBadge
      unavailable={ availability === UNAVAILABLE }
      title={ getAvailabilityMessage(availability) }
      { ...rest }
    />
    <AvailabilityIcon availability={ availability } />
  </div>
);

export default AvailabilityIconWithDotBadge;
